import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a824f9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default-layout" }

import NotificationBar from "@/components/Other/NotificationBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(NotificationBar)
  ]))
}
}

})